import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

type ShortcutGroup = {
	title: string;
	shortcuts: { keys: string[]; description: string }[];
};

const shortcutGroups: ShortcutGroup[] = [
	{
		title: 'Global',
		shortcuts: [
			{ keys: ['⌘P', '⌘.'], description: 'Command palette' },
			{ keys: ['⌘N'], description: 'Quick add link' },
			{ keys: ['⌘K'], description: 'Search' },
			{ keys: ['?'], description: 'Show shortcuts' },
			{ keys: ['⌘A'], description: 'Select all' },
			{ keys: ['Esc'], description: 'Clear selection' },
		],
	},
	{
		title: 'Navigation',
		shortcuts: [
			{ keys: ['J', '↓'], description: 'Next link' },
			{ keys: ['K', '↑'], description: 'Previous link' },
		],
	},
	{
		title: 'Actions',
		shortcuts: [
			{ keys: ['O', 'Enter'], description: 'Open link in new tab' },
			{ keys: ['E'], description: 'Archive link' },
			{ keys: ['L'], description: 'Change category' },
			{ keys: ['Q'], description: 'Move to queue' },
			{ keys: [']'], description: 'Archive + next' },
			{ keys: ['['], description: 'Archive + previous' },
		],
	},
];

type KeyboardShortcutsOverlayProps = {
	open: boolean;
	onOpenChange: (open: boolean) => void;
};

export function KeyboardShortcutsOverlay({ open, onOpenChange }: KeyboardShortcutsOverlayProps) {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-lg">
				<DialogHeader>
					<DialogTitle>Keyboard Shortcuts</DialogTitle>
				</DialogHeader>
				<div className="grid grid-cols-2 gap-6 pt-4">
					{shortcutGroups.map((group) => (
						<div key={group.title}>
							<h3 className="text-sm font-semibold text-muted-foreground mb-3">{group.title}</h3>
							<div className="space-y-2">
								{group.shortcuts.map((shortcut) => (
									<div
										key={shortcut.description}
										className="flex items-center justify-between gap-4"
									>
										<span className="text-sm">{shortcut.description}</span>
										<div className="flex gap-1">
											{shortcut.keys.map((key, i) => (
												<span key={i}>
													{i > 0 && <span className="text-muted-foreground mx-0.5">/</span>}
													<kbd className="px-1.5 py-0.5 text-xs font-mono bg-muted border rounded">
														{key}
													</kbd>
												</span>
											))}
										</div>
									</div>
								))}
							</div>
						</div>
					))}
				</div>
			</DialogContent>
		</Dialog>
	);
}
